var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserGuide = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#fff",
  opacity: 0.55
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#472179",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.2,
  d: "M18 25.314 26 25M18 28h3.81"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#472179",
  strokeWidth: 1.2,
  d: "M30.333 18.825v27.56m0-27.56 1.797-.674a18.2 18.2 0 0 1 12.74 0c1.085.407 1.797 1.393 1.797 2.49v22.623c0 1.505-1.621 2.535-3.112 1.976a14.45 14.45 0 0 0-10.11 0l-3.09 1.159c-.01.004-.022-.004-.022-.014m0-27.56-1.797-.674a18.2 18.2 0 0 0-12.74 0C14.713 18.558 14 19.544 14 20.64v22.623c0 1.505 1.621 2.535 3.111 1.976a14.45 14.45 0 0 1 10.111 0l3.089 1.159c.01.004.022-.004.022-.014"
})));
export default SvgUserGuide;